import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconAlertTriangle: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6.86667 2.6L1.6 12C1.48384 12.2011 1.42223 12.4291 1.42128 12.6614C1.42033 12.8936 1.48006 13.1221 1.59457 13.3242C1.70908 13.5263 1.87439 13.6949 2.07413 13.8135C2.27386 13.932 2.5011 13.9963 2.73333 14H13.2667C13.4989 13.9963 13.7261 13.932 13.9259 13.8135C14.1256 13.6949 14.2909 13.5263 14.4054 13.3242C14.5199 13.1221 14.5797 12.8936 14.5787 12.6614C14.5778 12.4291 14.5162 12.2011 14.4 12L9.13333 2.6C9.01376 2.40705 8.8469 2.24783 8.64857 2.13741C8.45023 2.027 8.227 1.96904 8 1.96904C7.773 1.96904 7.54977 2.027 7.35143 2.13741C7.1531 2.24783 6.98624 2.40705 6.86667 2.6Z"
    />
    <path
      d="M8 6V8.66667"
    />
    <path
      d="M8 11.3333H8.00667"
    />
  </svg>
);

export {
  IconAlertTriangle,
};
